import {
  FinancialModelSettings,
  FinancialModelSettingsType,
} from "@/feature/financial-model/api/types"
import { PayableConfiguration } from "../store"
import { PayableSetupPostRequest, PayableSetUpResponse } from "../types"

export const parsePayableConfiguration = (
  config: PayableSetUpResponse
): PayableConfiguration => {
  if (!config) {
    return {
      total_costs: {
        id: `total_costs`,
        level_of_granularity: null,
        modeling_approach: null,
        enabled: false,
      },
      direct_costs: {
        id: `direct_costs`,
        level_of_granularity: null,
        modeling_approach: null,
        enabled: false,
      },
      operating_costs: {
        id: `operating_costs`,
        level_of_granularity: null,
        modeling_approach: null,
        enabled: false,
      },
    }
  }
  return config.reduce((acc, item) => {
    acc[item.config_type] = {
      id: item.id,
      level_of_granularity: item.level_of_granularity,
      modeling_approach: item.modeling_approach ?? null,
      enabled: item.enabled,
    }
    return acc
  }, {} as PayableConfiguration)
}

export const parsePayableStoreAsPostRequest = (
  config: PayableConfiguration
): PayableSetupPostRequest => {
  const { total_costs, direct_costs, operating_costs } = config
  return {
    total_costs: {
      level_of_granularity: total_costs.level_of_granularity!,
      modeling_approach: total_costs.modeling_approach,
      enabled: total_costs.enabled,
    },
    direct_costs: {
      level_of_granularity: direct_costs.level_of_granularity,
      modeling_approach: direct_costs.modeling_approach,
      enabled: direct_costs.enabled,
    },
    operating_costs: {
      level_of_granularity: operating_costs.level_of_granularity,
      modeling_approach: operating_costs.modeling_approach,
      enabled: operating_costs.enabled,
    },
  }
}

export const getTwcModuleCompletitionStatus = (
  type: Extract<
    FinancialModelSettingsType,
    "receivables" | "payables" | "inventory"
  >,
  settings: FinancialModelSettings[]
) => {
  const status =
    settings.find((setting) => setting.type === type)?.status ?? `not_started`
  return status
}
